module.exports = __webpack_public_path__ + "static/img/dlcg.99cb3ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/dlcg.png
// module id = 9uXE
// module chunks = 1